import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { invoiceQuerySchema } from './invoice-query-schema';

export const invoiceMutationSchema = invoiceQuerySchema
  .omit({
    client: true,
    brand: true,
    partner: true,
    is_generating_pdfs: true,
  })
  .extend({
    client_id: z.number(),
    invoice_amount: currencyInput.mutationSchema(),
    digital_invoices_pdf: z.array(z.number()),
    printable_invoices_pdf: z.array(z.number()),
  });

export type InvoiceMutationSchema = z.infer<typeof invoiceMutationSchema>;

export const invoiceCreateSchema = invoiceMutationSchema
  .omit({
    id: true,
    invoice_number: true,
  })
  .extend({
    period_start: z.string(),
    period_end: z.string(),
    agreements: z.array(
      z.object({
        agreement_id: z.number(),
        agreement_deliverables: z.array(z.number()),
      })
    ),
  });

export type InvoiceCreateSchema = z.infer<typeof invoiceCreateSchema>;
